export default {
  title: 'Atrybuty dietetyczne',
};
